/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useTranslation } from "react-i18next";

import { useIntegrationsOptions } from "../../../../../../Pages/Integrations/hooks/useIntegrationsOptions";
import { NameValuePair } from "../../../../../../Pages/Integrations/types";
import { IGeneralDetailsProps } from "../../../../../../shared";
import useCustomResources from "../../../../../../shared/hooks/useCustomResources/useCustomResources";
import { useStyles } from "../../../../styles";
import DetailsCard from "../DetailsCard";
import DetailsCardItemText from "../DetailsCardItemText";
import DetailsCardItemTitle from "../DetailsCardItemTitle";

const IntegrationsGeneralDetails = ({ detailsData }: IGeneralDetailsProps) => {
  const { t } = useTranslation();
  const { paperCardItem } = useStyles();

  const { driverFileDestinationOptions, vehicleFolderNamingOptions } =
    useIntegrationsOptions();

  const { getConvertedStringToDate, renderMethodText } = useCustomResources();

  const getNameByValue = (value: string, options: NameValuePair[]): string => {
    return options.find(option => option.value === value)?.name ?? "";
  };

  const getSubCompaniesIncluded = (isIncluded: boolean) => {
    const translationKey = !isIncluded ? "not " : "";
    return t(`Details##${translationKey}included`);
  };

  return detailsData ? (
    <DetailsCard cardTitle={t("Details##details")} detailsData={detailsData}>
      <div css={css(paperCardItem)}>
        <DetailsCardItemTitle title={t("Details##company")} />
        <DetailsCardItemText textToRender={detailsData.company.name} />
      </div>

      <div css={css([paperCardItem])}>
        <DetailsCardItemTitle title={t("Table##method")} />
        <DetailsCardItemText
          textToRender={renderMethodText(detailsData.type)}
        />
      </div>

      <div css={css([paperCardItem])}>
        <DetailsCardItemTitle title={t("Details##file format")} />
        <DetailsCardItemText
          textToRender={t(`Settings##file formats##${detailsData.fileFormat}`)}
        />
      </div>

      <div css={css([paperCardItem])}>
        <DetailsCardItemTitle title={t("Dialog##vehicles folder naming")} />
        <DetailsCardItemText
          textToRender={getNameByValue(
            detailsData.vehicleFolderNaming,
            vehicleFolderNamingOptions
          )}
        />
      </div>

      <div css={css([paperCardItem])}>
        <DetailsCardItemTitle title={t("Dialog##driver file destination")} />
        <DetailsCardItemText
          textToRender={getNameByValue(
            detailsData.driverFolderNaming,
            driverFileDestinationOptions
          )}
        />
      </div>

      <div css={css([paperCardItem])}>
        <DetailsCardItemTitle title={t("Details##sub companies")} />
        <DetailsCardItemText
          textToRender={getSubCompaniesIncluded(
            detailsData.includeSubCompanies
          )}
        />
      </div>

      <div css={css(paperCardItem)}>
        <DetailsCardItemTitle title={t("Table##created by")} />
        <DetailsCardItemText textToRender={detailsData.creatorFullName} />
      </div>

      <div css={css(paperCardItem)}>
        <DetailsCardItemTitle title={t("Table##created at")} />
        <DetailsCardItemText
          textToRender={getConvertedStringToDate(detailsData.createdAt)}
        />
      </div>
    </DetailsCard>
  ) : (
    <></>
  );
};

export default IntegrationsGeneralDetails;
